export default {
    namespaced: true,
    state: {
        importPortfolio: false,
        addDealBuy: false,
        addDealSell: false,
        addManualIncome: false,
        addManualExpense: false,
        transferInBalance: false,
        transferOutBalance: false,
    },
    getters: {
        modalIsOpened: state => (name) => {
            return state[name];
        },
    },
    mutations: {
        toggleModal(state, name) {
            state[name] = !state[name]
        }
    }
}